import * as Yup from 'yup';

import { METHODS_REVERSE } from '@Utils/valuemappingFormHelpers';
import { TFunc } from '../../i18n/types';

// ? CreateValuemappingProfileRequest
const ValuemappingProfileSchema = (t: TFunc) =>
	Yup.object().shape(
		{
			profileName: Yup.string()
				.min(1, t('Cannot be empty'))
				.required(t('Profile Name is Required'))
				.typeError(t('Profile Name must be a string')),
			sensorTypes: Yup.mixed().when('sensorIds', {
				is: (sensorIds: string[]) => !sensorIds?.length,
				// createStringElementsSchema(VALID_SENSOR_TYPES, 'invalid type')
				then: Yup.array().of(Yup.string()).min(
					1,
					t(
						// eslint-disable-next-line quotes
						"Fields 'Sensor of type' and 'Individual sensor' cannot be empty at the same time.",
					),
				),
			}),
			sensorIds: Yup.mixed().when('sensorTypes', {
				is: (sensorTypes: string[]) => !sensorTypes?.length,
				then: Yup.array().of(Yup.string()).min(
					1,
					t(
						// eslint-disable-next-line quotes
						"Fields 'Sensor of type' and 'Individual sensor' cannot be empty at the same time.",
					),
				),
			}),
			mappings: Yup.array()
				.of(
					Yup.object().shape({
						order: Yup.number(),
						from: Yup.mixed().when(['order'], {
							is: order => order !== 0,
							then: Yup.number()
								.typeError(t('Should be an integer'))
								.integer(t('Should be an integer')),
							otherwise: Yup.string().notRequired().nullable(),
						}),
						method: Yup.mixed().when(['from'], {
							is: from => !!from,
							then: Yup.string().required(t('Required')),
							otherwise: Yup.string().notRequired(),
						}),
						to: Yup.mixed().when(['method'], {
							is: method => {
								return [METHODS_REVERSE.CUSTOM].includes(
									method,
								);
							},
							then: Yup.number()
								.typeError(t('Should be an integer'))
								.integer(t('Should be an integer'))
								.required(t('Required'))
								.nullable(),
							otherwise: Yup.string().nullable(),
						}),
						operator: Yup.mixed().when(['order'], {
							is: order => order !== 0,
							then: Yup.string()
								.oneOf(
									['=', '>', '<', '>=', '<='],
									t('A valid operator is required.'),
								)
								.required(t('Operator is required.')),
							otherwise: Yup.string().notRequired().nullable(),
						}),
					}),
				)
				.min(1, t('Need at least a mapping')),
		},
		[['sensorIds', 'sensorTypes']],
	);

export default ValuemappingProfileSchema;
